export default "__VITE_ASSET__D5pU1RdG__"